"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "palazzo-pignano": {
    "b8906a45": [{
      "hkey": "6b73533c",
      "slug": "scannabue-cascine-capri",
      "name": "Scannabue-Cascine Capri",
      "primary": true,
      "skipSearch": false
    }],
    "cascine-capri": [{
      "hkey": "6b73533c",
      "slug": "scannabue-cascine-capri",
      "name": "Scannabue-Cascine Capri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "palazzo-pignano"
    }],
    "39d75b6a": [{
      "hkey": "6b73533c",
      "slug": "scannabue-cascine-capri",
      "name": "Scannabue-Cascine Capri",
      "primary": true,
      "skipSearch": false
    }],
    "scannabue": [{
      "hkey": "6b73533c",
      "slug": "scannabue-cascine-capri",
      "name": "Scannabue-Cascine Capri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "palazzo-pignano"
    }]
  }
};
exports["default"] = _default;